import { render, staticRenderFns } from "./ClaimDocumentTabs.vue?vue&type=template&id=1d7560b5&"
import script from "./ClaimDocumentTabs.vue?vue&type=script&lang=js&"
export * from "./ClaimDocumentTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports